interface ForbiddenScreenProps {
  message?: string;
}

export function ForbiddenScreen({ message }: ForbiddenScreenProps) {
  return (
    <div className="text-center py-12">
      <div className="inline-flex items-center justify-center w-12 h-12 mb-3 bg-yellow-100 rounded-full">
        <svg
          className="w-6 h-6 text-yellow-600"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 15v.01M12 9v3m-7 4h14a2 2 0 001.732-3L13.732 4a2 2 0 00-3.464 0L3.268 13a2 2 0 001.732 3z"
          />
        </svg>
      </div>
      <p className="text-sm text-gray-600">
        {message ?? "Access denied. You don't have permission for this action."}
      </p>
    </div>
  );
}
